<template>
    <div id="IGCommentManagement">
        <div class="header">
            <div class="title">{{ $t("instagram.commentSettingsTitle") }}</div>
            <div class="description">{{ $t("instagram.commentSettingsDesc") }}</div>
        </div>
        <div class="body">
            <CommentManagement
                :channel="clone"
            />
        </div>
        <div class="form-footer">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import CommentManagement from "../../../IntegrationChannelsItem/CommentManagement.vue";
import _ from "lodash";

export default {
    name: "IGCommentManagement",
    props: {
        value: {
            required: true,
        },
    },
    components: {
        CommentManagement,
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
        };
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        handleSave() {
            const isValid = true;
            if (isValid) {
                var payload = _.cloneDeep(this.clone);
                if (payload.commentForward && (payload.commentForward.mode === "unset" || !payload.commentForward.mode)) {
                    payload.commentForward = null;
                }
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
};
</script>
<style scoped lang="scss">
#IGCommentManagement {
    .header {
        display: flex;
        flex-direction: column;
        padding: 20px;
        border-bottom: 1px solid #e5e5e5;

        .title {
            font-size: 24px;
            font-weight: 600;
            color: #333;
        }

        .description {
            font-size: 14px;
            color: #666;
            margin-top: 5px;
        }
    }

    .body {
        padding: 20px;
    }

    .form-footer {
        padding: 20px;
        border-top: 1px solid #e5e5e5;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
